import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, ArrowRight } from "lucide-react";

// Today: the Email Agent's tray count (new leads waiting for promote / screen out) instead of the old Proposed Leads list.
export function TrayCount() {
  const navigate = useNavigate();
  const [n, setN] = useState(null);
  useEffect(() => {
    api.get("/bd/tray").then((r) => setN((r.data || []).length)).catch(() => setN(null));
  }, []);
  if (!n) return null;
  return (
    <button onClick={() => navigate("/email-agent?tab=tray")} data-testid="today-tray-count"
      className="mb-6 w-full flex items-center gap-3 rounded-xl border border-[#F4C400]/50 bg-[#F4C400]/[0.06] px-4 py-3 text-left hover:border-[#F4C400] transition-colors">
      <Sparkles className="w-4 h-4 text-[#b08d00] shrink-0" />
      <span className="text-sm text-slate-800"><b data-testid="today-tray-count-n">{n}</b> new lead{n === 1 ? "" : "s"} in the Email Agent tray</span>
      <span className="ml-auto text-xs text-[#003E87] flex items-center gap-1">Review <ArrowRight className="w-3 h-3" /></span>
    </button>
  );
}
